export default __webpack_public_path__ + "static/media/gitHub.ae23dbb6.png";